import React, { memo } from 'react';
import _ from 'lodash';
import { message } from 'antd';
import MessageText from './message-text';
import MessageRich from './message-rich';
import MessageItems from './message-items';
import MessageFile from './message-file';
import MessagePhotoCard from './message-photo-card';
import MessageMiniProgramCard from './message-mini-program-card';
import MessageProductCard from './message-product-card';
import MessageSound from './message-sound';
import MessageRemind from './message-remind';
import MessageVideo from './message-video';
import MessageBox from './message-box';
import MessageTranslate from './message-translate';
import MessageSpeechToTxt from './message-speechtotxt';
import MessageRedbook from './message-red-book/message-redbook-base';
import MessageQuestionGuide from './message-douyin-card/message-question-guide';
import MessageRetainConsumer from './message-douyin-card/message-retain-consumer';
import MessagePremiumAppointment from './message-douyin-card/message-premium-appointment';
import MessageLeadsPhone from './message-douyin-card/message-leads-phone';

import { spacePhoneCheckApi } from '../client-card/api';
import Message from './message';

const MessageBase = memo(props => {
  const { data = {}, handleAddClue, handleImageStream, onLoad, handleClickRemindMessage } = props;
  const {
    fromType,
    content = [],
    msgType,
    noBaseStyle,
    id: streamId,
    translate: translateData,
    speechToTxt: speechToTxtData,
    conversation_id,
    track_id
  } = data;

  const handlePhoneSpaceCheck = tel => {
    spacePhoneCheckApi({ conv_id: conversation_id, track_id: track_id, tel: tel })
      .then(res => {})
      .catch(res => {
        if (res?.data?.message) {
          message.info(res.data?.message);
        }
      });
  };

  const isAgent = fromType === 'agent' || fromType === 'bot';
  const renderMessageType = content => {
    const messageArr = [];
    if (content && Array.isArray(content)) {
      content.forEach((msg, index) => {
        let text = '';
        const { type, body, size } = msg;

        const bodyText = typeof body === 'string' ? body : JSON.stringify(body);
        switch (type) {
          case 'text':
            const { clueCollection, extra } = data;
            const handleAddClueFun = clueCollection ? handleAddClue : () => null;
            text = (
              <MessageText
                data={bodyText}
                key={index}
                handleAddClue={handleAddClueFun}
                showClue={clueCollection}
                extra={extra}
                handlePhoneCheck={handlePhoneSpaceCheck}
              />
            );
            break;
          case 'rich_text':
            text = <MessageRich data={bodyText} key={index} onLoad={onLoad} />;
            break;
          case 'items':
            text = <MessageItems data={body} key={index} />;
            break;
          case 'file':
            text = (
              <MessageFile
                data={body}
                key={index}
                handleImageStream={handleImageStream}
                streamId={streamId}
                onLoad={onLoad}
              />
            );
            break;
          case 'photo_card':
            text = <MessagePhotoCard data={body} key={index} />;
            break;
          case 'mini_program_card':
            text = <MessageMiniProgramCard data={body} key={index} />;
            break;
          case 'product_card':
            text = <MessageProductCard data={body} size={size} key={index} />;
            break;
          case 'redbook_msg':
            text = <MessageRedbook data={body} key={index} />;
            break;
          case 'retain_consult_card':
            text = <MessageRetainConsumer data={body} key={index} />;
            break;
          case 'question_guide_msg_card':
            text = <MessageQuestionGuide data={body} key={index} />;
            break;
          case 'douyin_premium_online_appointment_card':
            text = <MessagePremiumAppointment data={body} key={index} />;
            break;
          case 'douyin_leads_phone_card':
            text = <MessageLeadsPhone key={index} />;
            break;
          case 'audio':
            text = <MessageSound data={body} key={index} />;
            break;
          case 'video':
            text = <MessageVideo data={body} key={index} />;
            break;
          default:
            text = '';
        }
        messageArr.push(text);
      });
    }
    return messageArr;
  };

  const getMsgColor = () => {
    let cssName = !isAgent ? 'msg-wrapper-agent' : 'msg-wrapper-client';
    if (msgType === 'internal') {
      cssName = 'msg-wrapper-internal';
    }
    if (data && data.extra && data.extra.anonymous_assistance_actual_agent_id) {
      cssName = 'msg-wrapper-anonymous';
    }
    if (noBaseStyle) {
      cssName = 'msg-wrapper-no-style';
    }
    if (content && Array.isArray(content) && content.length === 1) {
      let type = content[0].type;
      if (type === 'redbook_msg') {
        cssName = 'msg-wrapper-redbook';
      }
      // TODO... 新增抖音样式
    }
    return cssName;
  };
  const remindMessageData = _.get(data, 'customExtra.remindMessage', null);

  return (
    <MessageBox status={getMsgColor()}>
      {remindMessageData && (
        <MessageRemind message={remindMessageData} handleClickRemindMessage={handleClickRemindMessage} />
      )}
      <>{renderMessageType(content)}</>
      {translateData && !translateData.isSameLanguage ? <MessageTranslate translateData={translateData} /> : null}
      {speechToTxtData ? <MessageSpeechToTxt speechToTxtData={speechToTxtData} /> : null}
    </MessageBox>
  );
});

export default MessageBase;
